"use client";

import { FlashcardSet } from "@/graphql/schema";
import { usePublicProfiles } from "@/hooks/user/useUserData";
import { EmptyState } from "./SearchPageEmptyStates";
import WithPreviewerContentSection from "../../components/styled/WithPreviewerPageContentSection";
import { Flex, FlexColumn } from "@/components/Flex";
import WithPreviewerContentGrid from "../../components/styled/WithPreviewerPageContentGrid";
import UserContentCard from "@/components/cards/UserContentCard/UserContentCard";
import SearchPagePagination from "./SearchPagePagination";
import PageSidePreviewer from "../../components/PageSidePreviewer";

const FlashcardSetsTabContent = ({
    flashcardSets,
    totalPages,
}: {
    flashcardSets: FlashcardSet[];
    totalPages: number;
}) => {
    const usersIds = flashcardSets.map(flashcardSet => flashcardSet.userId);
    const { usersData } = usePublicProfiles(usersIds);

    if (!flashcardSets.length) {
        return <EmptyState />;
    }

    return (
        <WithPreviewerContentSection
            renderHeader={() => (
                <h2 style={{ fontSize: "1.7rem" }} data-testid="auto-id-ebf86ff5-ae17-4657-bd60-491c3bdf8e3a">
                    Flashcards
                </h2>
            )}
            renderGrid={() => (
                <Flex style={{ gap: "2rem" }}>
                    <FlexColumn style={{ flex: 1 }}>
                        {/* FLASHCARDSET GRID */}
                        <WithPreviewerContentGrid style={{ marginBottom: "4.1rem" }}>
                            {flashcardSets.map((flashcardSet, i) => (
                                <UserContentCard
                                    key={flashcardSet.flashcardSetId + i}
                                    flashcardSet={flashcardSet}
                                    ownerDetails={usersData[flashcardSet.userId]}
                                />
                            ))}
                        </WithPreviewerContentGrid>
                        {/* FLASHCARDS TAB PAGINATION */}
                        <SearchPagePagination totalPages={totalPages} />
                    </FlexColumn>
                    <PageSidePreviewer
                        initialFlashcardSet={flashcardSets[0]}
                        isNotesTab={false}
                        isFlascardsTab={true}
                    />
                </Flex>
            )}
        />
    );
};

export default FlashcardSetsTabContent;
